import { render, staticRenderFns } from "./wapNew.vue?vue&type=template&id=34e8f433&scoped=true"
import script from "./wapNew.vue?vue&type=script&lang=js"
export * from "./wapNew.vue?vue&type=script&lang=js"
import style0 from "./wapNew.vue?vue&type=style&index=0&id=34e8f433&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e8f433",
  null
  
)

export default component.exports